var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showViewer
    ? _c(
        "div",
        [
          _c("el-image-viewer", {
            ref: "glViewer",
            staticClass: "imageViewer",
            attrs: {
              id: "glViewer",
              "on-close": _vm.closeViewer,
              "on-switch": _vm.onSwitch,
              "url-list": _vm.imagesList,
              "initial-index": _vm.initialIndex,
            },
          }),
          _vm._v(" "),
          _vm.isShowAction
            ? _c("div", { staticClass: "view-action" }, [
                _c(
                  "div",
                  {
                    staticClass: "showOrigin noprint",
                    on: { click: _vm.handlePrint },
                  },
                  [
                    _c("i", { staticClass: "el-icon-printer" }),
                    _vm._v(_vm._s(_vm.$t("btn.print"))),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "showOrigin noprint",
                    on: { click: _vm.handleDownload },
                  },
                  [
                    _c("i", { staticClass: "el-icon-download" }),
                    _vm._v(_vm._s(_vm.$t("btn.download"))),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.istransfer === "0",
                        expression: "istransfer==='0'",
                      },
                    ],
                    staticClass: "sendOrigin noprint",
                    on: { click: _vm.handleSendOrigin },
                  },
                  [
                    _c("i", { staticClass: "el-icon-refresh-left" }),
                    _vm._v(_vm._s(_vm.$t("imagesViewer.applyOriginImage"))),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.istransfer === "1",
                        expression: "istransfer==='1'",
                      },
                    ],
                    staticClass: "sendOrigin noprint",
                  },
                  [
                    _c("i", { staticClass: "el-icon-refresh-left" }),
                    _vm._v(_vm._s(_vm.$t("imagesViewer.transitImage"))),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }